import script from "./moOrderDetailTabRow.vue?vue&type=script&setup=true&lang=js"
export * from "./moOrderDetailTabRow.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__